import React, { useState } from 'react';

import { Breadcrumbs } from '@/core/components/Breadcrumbs';
import { RecaptchaContextProvider } from '@/core/contexts/RecaptchaContext/RecaptchaContext';

import { ContactForm } from './ContactForm';
import { ContactSuccess } from './ContactSuccess';

export const Contact = () => {
  const [
    isFormSubmitted,
    setIsFormSubmitted,
  ] = useState(false);

  return (
    <>
      <Breadcrumbs />
      {isFormSubmitted ?
        <ContactSuccess setIsFormSubmitted={setIsFormSubmitted} /> :
        (
          <RecaptchaContextProvider>
            <ContactForm setIsFormSubmitted={setIsFormSubmitted} />
          </RecaptchaContextProvider>
        )}
    </>
  );
};
